module.exports = __webpack_public_path__ + "img/pdf-icon.ac5e9afd.png";